var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrice01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.927 16.755C30.927 26.005 24.527 34.655 15.927 36.755C7.327 34.655 0.927002 26.005 0.927002 16.755V6.75505L15.927 0.0883789L30.927 6.75505V16.755ZM15.927 33.4217C22.177 31.755 27.5937 24.3217 27.5937 17.1217V8.92171L15.927 3.72171L4.26034 8.92171V17.1217C4.26034 24.3217 9.677 31.755 15.927 33.4217ZM21.0103 25.0884L15.877 22.005L10.7603 25.0884L12.1103 19.255L7.59367 15.355L13.5603 14.8384L15.877 9.33838L18.2103 14.8217L24.177 15.3384L19.6437 19.255L21.0103 25.0884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice01);
export default __webpack_public_path__ + "static/media/price-01.3b28e9ce7872145156565a5e2b1873af.svg";
export { ForwardRef as ReactComponent };